import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Features from './components/Features';
import Partners from './components/Partners';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEOHead from '../../components/SEOHead';

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Edgeway Auto",
    "description": "Wholesale automotive company connecting dealers, investors, and industry professionals with quality vehicles at competitive prices.",
    "url": import.meta.env.VITE_SITE_URL || "https://example.com",
    "logo": {
      "@type": "ImageObject",
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/logo.png`
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-555-123-4567",
      "contactType": "customer service",
      "email": "info@edgewayauto.com",
      "availableLanguage": "English"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "1645 N Spring St Suite 210-L124",
      "addressLocality": "Beaver Dam",
      "addressRegion": "WI",
      "postalCode": "53916",
      "addressCountry": "US"
    },
    "foundingDate": "2009",
    "numberOfEmployees": "50-100",
    "industry": "Automotive Wholesale",
    "sameAs": [
      "https://linkedin.com/company/edgeway-auto",
      "https://facebook.com/edgewayauto"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Wholesale Automotive Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Vehicle Acquisition",
            "description": "Strategic sourcing of quality vehicles from trusted networks and auction houses"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Inventory Management",
            "description": "Comprehensive inventory solutions with detailed vehicle histories and condition reports"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Distribution Network",
            "description": "Efficient logistics and transportation services"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "150",
      "bestRating": "5"
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead jsonLd={jsonLd} />
      <Hero />
      <Services />
      <About />
      <Features />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
}